document.addEventListener('DOMContentLoaded', () => {
    const ANIMATION_DURATION = 2500;

    const counters = document.querySelectorAll('.percentage-text-l');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getAnimationConfig = el => {
        const displayType = el.dataset.displayType || 'percentage';
        const value = el.dataset.value || el.textContent.trim();
        const suffix = el.dataset.suffix || '';

        // Parse numeric value. Nachkommastellen aus der QUELLE uebernehmen: der Zaehler
        // rundete bisher hart (Math.round), aus "10.5" wurde eine angezeigte 10 und aus
        // "2.4" eine 2 — die Kachel widersprach damit ihrem eigenen Fliesstext ("um 10,5 %").
        const numMatch = value.match(/\d+(\.\d+)?/);
        const numValue = numMatch ? parseFloat(numMatch[0]) : 0;
        const decimals = numMatch && numMatch[0].includes('.') ? numMatch[0].split('.')[1].length : 0;

        // Determine suffix based on display type
        let finalSuffix = '';
        if (displayType === 'percentage') {
            finalSuffix = '%';
        } else if (displayType === 'multiplier') {
            finalSuffix = 'x';
        } else if (suffix) {
            finalSuffix = suffix;
        }

        return {
            type: displayType,
            value: numValue,
            decimals: decimals,
            suffix: finalSuffix,
            originalText: el.textContent.trim()
        };
    };

    // Deutsch schreibt Dezimalkomma. Ohne das steht "10.5 %" auf einer sonst
    // durchgehend deutschen Seite.
    const isGerman = (document.documentElement.lang || '').toLowerCase().startsWith('de');
    const formatValue = (n, decimals) => {
        const s = n.toFixed(decimals);
        return isGerman ? s.replace('.', ',') : s;
    };

    const animate = el => {
        if (el.dataset.animated) return;
        el.dataset.animated = '1';

        const config = getAnimationConfig(el);

        // Find the value span (suffix span will remain untouched)
        const valueSpan = el.querySelector('.percentage-text-value');
        if (!valueSpan) {
            // Fallback: if structure doesn't have spans, animate the whole element
            // This handles edge cases where HTML might not be updated yet
            const spacing = config.suffix ? '\u200A' : '';
            el.textContent = formatValue(config.value, config.decimals) + spacing + config.suffix;
            return;
        }

        // If display type is 'text', don't animate
        if (config.type === 'text') {
            return;
        }

        // If no numeric value found, don't animate
        if (config.value === 0 && config.type !== 'percentage') {
            return;
        }

        // If reduced motion is preferred, show final value immediately
        if (reduceMotion) {
            valueSpan.textContent = formatValue(config.value, config.decimals);
            return;
        }

        const start = performance.now();
        const easeOutQuint = t => 1 - Math.pow(1 - t, 5);

        const tick = now => {
            const progress = Math.min((now - start) / ANIMATION_DURATION, 1);
            const currentValue = formatValue(easeOutQuint(progress) * config.value, config.decimals);
            valueSpan.textContent = currentValue;
            
            if (progress < 1) {
                requestAnimationFrame(tick);
            }
        };

        // Start animation from 0 (suffix span remains untouched)
        valueSpan.textContent = '0';
        requestAnimationFrame(tick);
    };

    const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) animate(entry.target);
        });
    }, { threshold: 0.5 });

    counters.forEach(el => io.observe(el));
});